import { Component, signal } from '@angular/core';
import { DrillPlanImportResult } from 'src/app/wellbore-inputs/models/drill-plan.models';
import { WellCatImportResult } from 'src/app/wellbore-inputs/models/well-cat.models';

@Component({
  selector: 'app-integrations-page',
  templateUrl: './integrations-page.component.html',
  styles: `
    .integration-group-fieldset {
      margin: 0;
      padding: 1rem 0.75rem 0.75rem;
      border: 1px solid var(--p-content-border-color);
      border-radius: 0.5rem;
      min-inline-size: 0;
    }

    .integration-group-fieldset > legend {
      margin-left: 0.75rem;
      padding: 0 0.5rem;
    }

    .integrations-container {
      max-width: 1400px;
      margin: 0 auto;
    }

    .integrations-grid {
      min-height: 300px;
    }
  `,
  standalone: false
})
export class IntegrationsPageComponent {
  public readonly showDrillPlanImportDialog = signal(false);
  public readonly showWellCatImportDialog = signal(false);

  onImportComplete(_result: DrillPlanImportResult): void {
    // Counts and warnings are shown as toasts by DrillPlanImportComponent.
    // Navigate users to affected sections if needed.
  }

  onWellCatImportComplete(_result: WellCatImportResult): void {
    // Counts and warnings are shown as toasts by WellCatImportComponent.
    // Navigate users to affected sections if needed.
  }
}
